import {resolveBackground} from '#core/utils/color-utils.js';
import {icon} from '#core/utils/style-utils.js';

export function marketInstructionsFactory(PALETTE) {
    return {
        MarketInstructions: {
            container: {
                style: {
                    height: 'initial', // Override mojito defaults
                    _mobile_height: 'initial', // Override mojito defaults
                },
            },
            contentContainer: {
                style: {
                    borderRadius: PALETTE.MARKET_INSTRUCTIONS_CONTENT_BORDER_RADIUS,
                    boxShadow: PALETTE.MARKET_INSTRUCTIONS_CONTENT_SHADOW,
                    ...resolveBackground(PALETTE.MARKET_INSTRUCTIONS_CONTENT_BG),
                    _mobile_padding: '0px 0px 8px 0',
                },
            },
            headerSection: {
                style: {
                    padding: '0 8px 8px 0', // Override mojito defaults
                    _mobile_padding: '8px 8px 8px 0',
                },
            },
            title: {
                style: {
                    ...PALETTE.MARKET_INSTRUCTIONS_TITLE_TEXT,
                },
            },
            contentText: {
                style: {
                    ...PALETTE.MARKET_INSTRUCTIONS_CONTENT_TEXT,
                },
            },
            closeImgBtn: {
                buttonIcon: {
                    src: 'close',
                    style: {
                        width: 8,
                        height: 8,
                        minWidth: 8,
                        minHeight: 8,
                        fill: PALETTE.MARKET_INSTRUCTIONS_CLOSE_BUTTON.CLOSE_BUTTON_ICON_COLOR,
                    },
                },
            },
        },
        EventMarkets: {
            matchAccaMarketInstructions: {
                logo: icon(PALETTE.MARKET_INSTRUCTIONS_BET_BUILDER_ICON_COLOR, 'system-betbuilder'),
            },
            genericMarketContent: {
                market: {
                    selectionButton: {
                        view: {
                            _mobile_nameDisplay: 'show',
                        },
                    },
                },
            },
        },
    };
}
